import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { ConfirmNewEmailContainer } from '../../modules/auth/containers/ConfirmNewEmailContainer';

export const ConfirmNewEmailView = (): ReactElement => (
  <AuthContainer>
    <ConfirmNewEmailContainer />
  </AuthContainer>
);
